import React, {useContext} from "react";
import { graphql, useStaticQuery, Link } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"
import CartContext from '../../context/CartContext'

const CartLink = ({show}) => {
  const {experiences} = useContext(CartContext)
  const intl = useIntl()
  const data = useStaticQuery(graphql`
  query expMenuQuery{
    expMenuQueryEN : allBlockContentBlockCollectableExperiences(filter: {langcode: {eq: "en"}, popup_booking_cta: {title: {ne: "test"}}}) {
      nodes {
        popup_booking_cta {
          title
          url
        }
      }
    }

    expMenuQueryFR : allBlockContentBlockCollectableExperiences(filter: {langcode: {eq: "fr"}, popup_booking_cta: {title: {ne: "test"}}}) {
      nodes {
        popup_booking_cta {
          title
          url
        }
      }
    }
  }
`)
let count = 0;

experiences.forEach((element) => {
  count += 1;
});

let dataCartLinkTicket
switch (intl.locale) {
    case "fr":
      if (data.expMenuQueryFR) {
        dataCartLinkTicket = data.expMenuQueryFR.nodes[0]
      }
      break
    default:
      if (data.expMenuQueryEN) {
        dataCartLinkTicket = data.expMenuQueryEN.nodes[0]
  }
}

  return (
    <div id="cartLink" className='cartLinkSticky'>
      <Link to={dataCartLinkTicket.popup_booking_cta?.url}>
        <div className='ticket'>
          <i className='icon-ticket'></i>
          <div className="numbers-panier">
            {count}
          </div>
        </div>
        <span className={`description ${show}`}>{intl.formatMessage({ id: "cart-link.msg-1" })}</span>
      </Link>
    </div>
  )
}

export default CartLink